/* Weekend Redneck, collection filter sidebar + sort */
(function () {
  'use strict';

  function init() {
    var section = document.querySelector('[data-collection]');
    if (!section) return;

    var toggle = section.querySelector('[data-filter-toggle]');
    var label = section.querySelector('[data-filter-label]');
    if (toggle && !toggle.dataset.init) {
      toggle.dataset.init = '1';
      toggle.addEventListener('click', function () {
        var hidden = section.classList.toggle('is-filter-hidden');
        toggle.setAttribute('aria-expanded', hidden ? 'false' : 'true');
        if (label) label.textContent = hidden ? 'Show Filter' : 'Hide Filter';
      });
    }

    var sort = section.querySelector('[data-sort]');
    if (sort && !sort.dataset.init) {
      sort.dataset.init = '1';
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
